import { saveAs } from "file-saver";
import Axios, { AxiosRequestConfig } from "axios";
import { getAuthorizationToken } from "../utilities/tokenUtilities";

export default class ApiClient {
  constructor() {
    Axios.defaults.baseURL = process.env.REACT_APP_TR_API_BASE_URL;
    Axios.defaults.headers.Authorization = `Bearer ${getAuthorizationToken()}`;
    Axios.defaults.headers.Pragma = "no-cache";
  }

  async get(url: string) {
    const response = await Axios.get(url);
    return response.data;
  }

  async post(url: string, data: any) {
    const response = await Axios.post(url, data);
    return response.data;
  }

  async put(url: string, data: any) {
    const response = await Axios.put(url, data);
    return response.data;
  }

  async delete(url: string) {
    const response = await Axios.delete(url);
  }

  async download(url: string, methodType: "get" | "post" = "get", data?: any, fileName?: string|undefined) {
    const config: AxiosRequestConfig = {
      responseType: "blob"
    };
    switch (methodType) {
      case "get":
        downloadGet(url, config, fileName);
        break;
      case "post":
        downloadPost(url, data, config);
        break;
      default:
        downloadGet(url, config, fileName);
    }
  }
}

async function downloadGet(url: string, config: AxiosRequestConfig, fileName?: string|undefined) {
  await Axios.get(url, config).then(response => {
    if(!fileName){
      let contentDisposition = response.headers["content-disposition"];
      fileName = 'dokument.pdf';
      if(contentDisposition) {
        fileName = decodeURI(
          contentDisposition.match(
            /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/
          )[3]
        );
      }
    }
    saveAs(new Blob([response.data]), fileName);
  });
}

async function downloadPost(
  url: string,
  data: any,
  config: AxiosRequestConfig
) {
await Axios.post(url, data, config).then(response => {  
  let contentDisposition = response.headers["content-disposition"];
  let fileName = 'dokument.xlsx';
  if (contentDisposition) {
    fileName = decodeURI(
      contentDisposition.match(
      /filename[^;=\n]*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/
      )[3]
    );
    }    
  saveAs(new Blob([response.data]), fileName);
  });
}
